// extracted by mini-css-extract-plugin
export var gridItems = "Item-module--gridItems--ef819";
export var grow = "Item-module--grow--f8c9c";
export var hidden = "Item-module--hidden--68f08";